module.exports = __webpack_public_path__ + "img/google.c775b211.png";